import { render, staticRenderFns } from "./pbi-group-mapping.page.vue?vue&type=template&id=673106e4"
import script from "./pbi-group-mapping.page.vue?vue&type=script&lang=ts"
export * from "./pbi-group-mapping.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports